document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('index-swiper')) {
    class IndexSwiper extends HTMLElement {
      constructor() {
        super()
        this.container = this.querySelector('.index-swiper-container')
        this.current_index = 0
        this.youtube_list = this.querySelectorAll('[data-plyr-provider]')
        this.video_list = this.querySelectorAll(
          '.shopify-lazy-common-video .common-lazy-video, .common-video-index video'
        )
        this.size = this.dataset.size
        this.video_btn = this.querySelectorAll('.index-swiper-btn')
        this.swiper_obj = this.querySelector('.swiper')
        this.swiper = null
        this.player_list = []
        this.has_viewport_played = false
        this.pending_first_play = false
        this.type =
          this.video_list && this.video_list.length > 0 ? 'video' : 'youtube'
        this.line_clamp = this.getAttribute('data-line_clamp')
        this.video_first_play =
          this.getAttribute('data-video_first_play') == 'true' ? true : false
      }
      connectedCallback() {
        this.detectObserver()
      }
      detectObserver() {
        let preloadDistance = window.innerHeight / 2
        if (this.container) {
          const resizeObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                this.initDetectVideo()
                this.initSwiper()
                this.initVideoBtnClickEvent()
                if (this.line_clamp > 0) {
                  this.initLineClamp()
                }
                this.preloadVideoFn()
                this.initViewportVideoPlayback()
                resizeObserver.disconnect()
              }
            },
            {
              threshold: 0,
              rootMargin: `${preloadDistance}px 0px ${preloadDistance}px 0px`,
            }
          )
          resizeObserver.observe(this.container)
        }
      }
      initDetectVideo() {
        const videoContainers = this.querySelectorAll('.common-video-index')
        if (videoContainers && videoContainers.length > 0) {
          for (let videoContainer of videoContainers) {
            const index = videoContainer.dataset.index
            const videos = videoContainer.querySelectorAll('video')
            if (videos && videos.length > 0) {
              this.player_list[index] = this.createVideoPlayer(videos)
            }
          }
        } else if (this.video_list && this.video_list.length > 0) {
          this.player_list.push(...this.video_list)
        }
        if (!this.youtube_list) return
        for (let item of this.youtube_list) {
          const ite = new Plyr(item, {
            controls: ['progress', 'fullscreen'],
            tooltips: { controls: false, seek: false },
          })
          ite.is_youtube = true
          if (item.dataset.index) {
            this.player_list[item.dataset.index] = ite
          } else {
            this.player_list.push(ite)
          }
          this.bindFullscreenUnmute(ite)
        }
        this.prepareFirstVideo()
      }
      createVideoPlayer(videos) {
        const videoList = [...videos]
        const loadVideoSources = (video) => {
          if (video.dataset.lazyLoaded == 'true') return

          const lazySources = video.querySelectorAll('source[data-src]')
          if (!lazySources || lazySources.length == 0) return

          lazySources.forEach((source) => {
            source.src = source.dataset.src
            source.removeAttribute('data-src')
          })
          video.load()
          video.dataset.lazyLoaded = 'true'
        }
        const getPlayableVideos = () => {
          const visibleVideos = videoList.filter((video) => {
            const style = window.getComputedStyle(video)
            return style.display !== 'none' && style.visibility !== 'hidden'
          })
          return visibleVideos.length > 0 ? visibleVideos : videoList
        }
        return {
          get paused() {
            return getPlayableVideos().every((video) => video.paused)
          },
          load() {
            getPlayableVideos().forEach((video) => {
              loadVideoSources(video)
            })
          },
          play() {
            getPlayableVideos().forEach((video) => {
              loadVideoSources(video)
              const playPromise = video.play()
              if (playPromise && playPromise.catch) playPromise.catch(() => {})
            })
          },
          pause() {
            videoList.forEach((video) => video.pause())
          },
        }
      }
      bindFullscreenUnmute(player) {
        let prevMuted = true
        let prevVolume = 0
        player.on('enterfullscreen', () => {
          prevMuted = player.muted
          prevVolume = player.volume
          player.muted = false
          if (!player.volume) player.volume = 1
        })
        player.on('exitfullscreen', () => {
          player.muted = prevMuted
          player.volume = prevVolume
        })
      }
      initSwiper() {
        if (!this.swiper_obj) return
        const slider_pc_num = this.getAttribute('data-swiper_pc_num')
          ? this.getAttribute('data-swiper_pc_num')
          : 1
        const slider_ipad_num = this.getAttribute('data-swiper_ipad_num')
          ? this.getAttribute('data-swiper_ipad_num')
          : slider_pc_num
        const slider_m_num = this.getAttribute('data-swiper_m_num')
          ? this.getAttribute('data-swiper_m_num')
          : slider_ipad_num
        const prevButton = this.querySelector('.swiper-button-prev')
        const nextButton = this.querySelector('.swiper-button-next')
        const scrollbar = this.querySelector('.swiper-scrollbar')
        const pagination = this.querySelector('.swiper-pagination')
        const swiper_auto =
          this.getAttribute('data-swiper_auto') == 'true' ? true : false
        const swiper_auto_time = this.getAttribute('data-swiper_auto_time') * 1
        const loop =
          this.getAttribute('data-swiper_loop') == 'true' ? true : false
        const speed = this.getAttribute('data-swiper_speed') * 1000
        let autoplay = false
        if (swiper_auto) {
          autoplay = {
            delay: swiper_auto_time,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          }
        }
        this.swiper = new Swiper(this.swiper_obj, {
          slidesPerView: slider_pc_num,
          spaceBetween: 20,
          autoplay: autoplay,
          loop: loop,
          speed: speed,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
          breakpoints: {
            1024: {
              spaceBetween: 15,
              slidesPerView: slider_ipad_num,
            },
            589: {
              spaceBetween: 10,
              slidesPerView: slider_m_num,
            },
          },
        })
      }
      initVideoBtnClickEvent() {
        for (let btn_item of this.video_btn) {
          btn_item.addEventListener('click', () => {
            let index = btn_item.dataset.index
            let flag =
              btn_item.getAttribute('data-video_fullscreen') == 'true'
                ? true
                : false
            this.pauseVideoFn(this.current_index)
            this.playVideoFn(index)
            if (flag) {
              this.playVideoFn(index)
              this.player_list[index].fullscreen.enter()
            }
          })
        }
      }
      playVideoFn(play_index) {
        this.current_index = play_index
        this.video_btn[play_index].classList.add('active')
        this.video_btn[play_index]
          .closest('.index-swiper-item')
          .classList.add('active')
        this.player_list[play_index] &&
          this.player_list[play_index].paused &&
          this.player_list[play_index].play()
      }
      pauseVideoFn(pause_index) {
        this.video_btn[pause_index].classList.remove('active')
        this.video_btn[pause_index]
          .closest('.index-swiper-item')
          .classList.remove('active')
        this.player_list[pause_index] &&
          !this.player_list[pause_index].paused &&
          this.player_list[pause_index].pause()
      }
      preloadVideoFn() {
        this.player_list.forEach((player) => {
          if (player && player.load) player.load()
        })
      }
      prepareFirstVideo() {
        let flag =
          this.video_btn[0] &&
          this.video_btn[0].getAttribute('data-video_loop') == 'true'
            ? true
            : false

        if (this.player_list[0] && this.player_list[0].is_youtube) {
          this.player_list[0].on('ready', (event) => {
            this.player_list[0].is_ready = true
            this.player_list[0].muted = true
            this.player_list[0].volume = 0
            if (flag) {
              this.player_list[0].loop = { active: true }
            }
            if (this.pending_first_play) this.playFirstVideoInViewport()
          })
        }
        if (!flag) this.detectLoopVideo()
      }
      initViewportVideoPlayback() {
        if (!this.video_first_play) return
        if (!this.player_list[0] || !this.container) return

        const playWhenVisible = (observer) => {
          if (this.has_viewport_played) return
          this.has_viewport_played = true
          if (observer) observer.disconnect()
          this.playFirstVideoInViewport()
        }

        const isInViewport =
          this.container.getBoundingClientRect().top < window.innerHeight &&
          this.container.getBoundingClientRect().bottom > 0
        if (isInViewport) {
          playWhenVisible()
          return
        }

        const viewportObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) playWhenVisible(viewportObserver)
          },
          { threshold: 0.1 }
        )
        viewportObserver.observe(this.container)
      }
      playFirstVideoInViewport() {
        if (!this.player_list[0]) return
        if (this.player_list[0].is_youtube && !this.player_list[0].is_ready) {
          this.pending_first_play = true
          return
        }
        this.pending_first_play = false
        this.playVideoFn(0)
      }
      detectLoopVideo() {
        for (let item of this.youtube_list) {
          let j = +item.dataset.index
          this.player_list[j] &&
            this.player_list[j].on('ended', (event) => {
              this.pauseVideoFn(j)
              j + 1 < this.size &&
                this.player_list[j + 1] &&
                this.swiper.slideTo(j + 1) &&
                this.playVideoFn(j + 1)
            })
        }
      }
      initLineClamp() {
        const all_ele = this.querySelectorAll('.ellipsis-content')
        const btn_ele = this.querySelectorAll('.index-linka')
        if (!all_ele || !btn_ele) return
        const single_h = getComputedStyle(
          this.querySelector('.ellipsis-content')
        ).lineHeight.replace('px', '')
        const three_h = Math.ceil(single_h * 3)
        for (let all_item of all_ele) {
          let content_h = Math.ceil(all_item.offsetHeight)
          if (content_h > three_h) {
            all_item.classList.add('text-ellipsis')
          } else {
            all_item.closest('.content').classList.add('no-more')
          }
        }
        for (let btn_item of btn_ele) {
          btn_item.addEventListener('click', () => {
            if (btn_item.closest('.content').classList.contains('active')) {
              btn_item.innerText = 'Learn More'
            } else {
              btn_item.innerText = 'Learn Less'
            }
            btn_item.closest('.content').classList.toggle('active')
          })
        }
      }
    }
    customElements.define('index-swiper', IndexSwiper)
  }
})
